import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../../pages/Login.page';

export const PublicRoutes: FC = () => {
  return <Routes>
    <Route path="/login" element={<LoginPage/>}/>
    <Route path="*" element={<Navigate to="/login" replace={true}/>}/>
  </Routes>
};
